import { useTranslation } from "next-i18next";

import { cn } from "@/common/utils/css.utils";

type ShowroomModelLabelProps = {
  className?: string;
};

export const ShowroomModelLabel = ({ className }: ShowroomModelLabelProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full bg-attention-100 px-2 py-0.5 font-title text-sm leading-6 text-attention-900",
        className
      )}
    >
      <div className="h-4" />
      {t("label:label-showroom-model")}
    </span>
  );
};
